<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-toolbar color="primary" dark flat>
            <v-icon>mdi-silverware</v-icon>
            <v-toolbar-title>Archivos compartidos</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              v-if="!local_storage"
              text
              outlined
              elevation="1"
              @click="dialog_nuevo = true"
            >
              Nuevo
            </v-btn>
            <v-btn
              v-if="local_storage"
              text
              elevation="1"
              @click="iniciarSesion()"
            >
              Iniciar sesión
            </v-btn>
          </v-toolbar>
          <v-row>
            <v-col>
              <v-card-text>
                <v-treeview
                  v-model="tree"
                  :load-children="listarArchivosHijos"
                  :items="items_carpetas"
                  selected-color="indigo"
                  open-on-click
                  selectable
                  return-object
                  expand-icon="fas fa-chevron-down"
                  on-icon="fas fa-bookmark"
                  off-icon="far fa-bookmark"
                  indeterminate-icon="fas fa-minus-square"
                >
                </v-treeview>
              </v-card-text>
            </v-col>

            <v-divider vertical></v-divider>

            <v-col cols="12" md="6">
              <v-card-text>
                <div
                  v-if="tree.length === 0"
                  key="title"
                  class="text-h6 font-weight-light grey--text pa-4 text-center"
                >
                  Seleccione alguna carpeta
                </div>

                <v-scroll-x-transition group hide-on-leave>
                  <v-chip
                    v-for="(selection, i) in tree"
                    :key="i"
                    color="grey"
                    dark
                    small
                    class="ma-1 pa-4"
                  >
                    <v-icon left small> fas fa-file-alt </v-icon>
                    {{ selection.name }}
                  </v-chip>
                </v-scroll-x-transition>
              </v-card-text>
            </v-col>
          </v-row>

          <v-divider></v-divider>

          <v-footer>
            <v-btn text @click="listarArchivos()"> Recargar </v-btn>

            <v-spacer></v-spacer>

            <v-btn
              class="white--text"
              color="green darken-1"
              depressed
              @click="descargarArchivos()"
            >
              Descargar
            </v-btn>
          </v-footer>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog_nuevo" width="500" persistent>
      <v-card>
        <v-card-title> Nuevo(s) archivo(s) </v-card-title>
        <v-card-text class="pb-0">
          <v-row>
            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="nombre_carpeta"
                :items="items_nombre_carpeta"
                label="Carpeta"
                outlined
                dense
                hide-details
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="nombre_tipo_carpeta"
                :items="items_tipo_documentos"
                label="Carpeta"
                outlined
                dense
                hide-details
              ></v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-file-input
                v-model="archivos"
                label="Archivo"
                outlined
                dense
                multiple
                counter
                show-size
              ></v-file-input>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="crearSesionCarga()">Guardar</v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="cerrarDialogNuevo()">Cancelar</v-btn>
        </v-card-actions>
      </v-card>

      <v-overlay :value="progress_circular">
        <v-progress-circular
          indeterminate
          size="100"
          color="primary"
          width="10"
        ></v-progress-circular>
      </v-overlay>
    </v-dialog>

    <v-dialog v-model="dialog_estatus_archivos" width="500" persistent>
      <v-card>
        <v-card-title>Cargando archivo(s)</v-card-title>
        <v-card-text>
          <v-list-item
            two-line
            dense
            v-for="(item, i) in archivos_creados"
            :key="i"
          >
            <v-list-item-content>
              <v-list-item-title>{{ item.nombre }}</v-list-item-title>
              <v-list-item-subtitle>{{ item.estatus }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="cerrarDialogNuevo()">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" top color="primary">
      {{ snackbar_text }}
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from "axios";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import one_drive_api from "../../view/OneDriveApi";

export default {
  data: () => ({
    snackbar: false,
    snackbar_text: "",
    puede_actualizar: true,
    dialog_nuevo: false,
    dialog_estatus_archivos: false,
    progress_circular: false,
    headers: [{ text: "Nombre", value: "name" }],
    one_drive_cred: false,
    url_code_autorizacion: "",
    credenciales: [],
    archivos: [],
    archivos_creados: [],
    local_storage: true,
    items_carpetas: [],
    //////////////////////////
    items_nombre_carpeta: [
      "ADMINISTRACION",
      "FINANZAS",
      "GERENCIA",
      "INFORMATICA",
      "LEGAL",
      "OPERACIONES",
    ],
    nombre_carpeta: "",
    items_tipo_documentos: [
      "FORMULARIOS",
      "PRESENTACIÓN",
      "PROCEDIMIENTO",
      "PROCESOS",
      "MANUALES",
    ],
    nombre_tipo_carpeta: "",
    tree: [],
    contador: 0,
    items_permisos: [],
  }),
  created() {
    this.listarPermisosArea();
    this.tiene_cred_one_drive();
  },
  methods: {
    listarPermisosArea() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get(
          "api/PermisosCompartidoAreas/Listar/" +
            this.$store.state.usuario.idUsuario,
          configuracion
        )
        .then((response) => {
          //console.log(response.data);
          this.items_permisos = response.data;
          this.listarArchivos();
        });
    },
    async listarPermisosTipo(id_area) {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      var result = await axios.get(
        "api/PermisosCompartidoTipos/Listar/" + id_area,
        configuracion
      );
      //console.log(result.data);
      return result.data[0].nombre;
    },
    async tiene_cred_one_drive() {
      const inter = setInterval(async () => {
        var credenciales_drive = await one_drive_api.listarCredencialesOneDrive(
          this.$store.state.usuario.idUsuario
        );
        if (credenciales_drive.length > 0) {
          localStorage.setItem("credentials", "si");
          this.flag_credenciales();
          clearInterval(inter);
        }
      }, 1000);
    },
    flag_credenciales() {
      if (localStorage.getItem("credentials")) {
        this.local_storage = false;
      } else {
        this.local_storage = true;
      }
    },
    async listarArchivos() {
      this.items_carpetas = [];
      var credenciales_drive = await one_drive_api.listarCredencialesOneDrive(
        this.$store.state.usuario.idUsuario
      );
      var refresh_token = this.desencriptarDato(
        this.getLlave("refresh_token", credenciales_drive).valor
      );
      var result_t = await axios.post("api/Usuarios/ObtenerNuevoToken", {
        redirect_uri: "http://localhost:8080/authGoogleDrive",
        refresh_token: refresh_token,
      });

      let header = {
        Authorization: "Bearer " + result_t.data.access_token,
        "Content-Type": "application/json",
      };
      let configuracion = { headers: header };

      let result = await axios
        .get(
          "https://graph.microsoft.com/v1.0/me/drive/root:/" +
            "INTRANET/COMPARTIDO" +
            ":/children",
          configuracion
        )
        .catch((error) => {
          return error.response;
        });

      //console.log(result.data.value);

      result.data.value.forEach((element) => {
        this.items_permisos.forEach((element_p, index) => {
          if (element.name == element_p.nombre) {
            var fond = this.items_carpetas.some(
              (el) => el.name === element_p.nombre
            );
            if (!fond) {
              this.items_carpetas.push({
                id: element.id,
                name: element.name,
                children: [],
              });
            }
          }
        });
      });
    },
    async listarArchivosHijos(item) {
      //console.log("item", item);
      if (item) {
        var credenciales_drive = await one_drive_api.listarCredencialesOneDrive(
          this.$store.state.usuario.idUsuario
        );
        var refresh_token = this.desencriptarDato(
          this.getLlave("refresh_token", credenciales_drive).valor
        );
        var result_t = await axios.post("api/Usuarios/ObtenerNuevoToken", {
          redirect_uri: "http://localhost:8080/authGoogleDrive",
          refresh_token: refresh_token,
        });

        let header = {
          Authorization: "Bearer " + result_t.data.access_token,
          "Content-Type": "application/json",
        };
        let configuracion = { headers: header };

        let result = await axios
          .get(
            "https://graph.microsoft.com/v1.0/me/drive/items/" +
              item.id +
              "/children",
            configuracion
          )
          .catch((error) => {
            return error.response;
          });

        //console.log("RESULT", result.data.value);

        result.data.value.forEach((element) => {
          if (element.folder) {
            var index = this.items_carpetas.findIndex(
              ({ id }) => id === item.id
            );
            if (element.folder.childCount > 0) {
              this.items_permisos.forEach((element_p) => {
                if (element_p.nombre == item.name) {
                  if (element_p.nombre_tipo == element.name) {
                    this.items_carpetas[index].children.push({
                      id: element.id,
                      name: element.name,
                      children: [],
                    });
                  }
                }
              });
            }
          } else if (element.file) {
            for (var i = 0; i < this.items_carpetas.length; i++) {
              var index = this.items_carpetas[i].children.findIndex(
                ({ id }) => id === item.id
              );
              if (index != -1) {
                this.items_carpetas[i].children[index].children.push({
                  id: element.id,
                  name: element.name,
                });
              }
            }
          }
        });
      }
    },
    //ABRE UNA NUEVA PESTAÑA PARA EL PROCESO DE AUTH EN EL COMPONENTE LoginOneDrive
    iniciarSesion() {
      one_drive_api.AuthUsuario();
    },
    async crearSesionCarga() {
      if (
        this.nombre_carpeta === "" ||
        this.nombre_tipo_carpeta === "" ||
        this.archivos.length == 0
      ) {
        this.snackbar_text = "Seleccione carpeta y al menos un archivo";
        this.snackbar = true;
        return;
      }

      var credenciales_drive = await one_drive_api.listarCredencialesOneDrive(
        this.$store.state.usuario.idUsuario
      );
      var refresh_token = this.desencriptarDato(
        this.getLlave("refresh_token", credenciales_drive).valor
      );
      var result_t = await axios.post("api/Usuarios/ObtenerNuevoToken", {
        redirect_uri: "http://localhost:8080/authGoogleDrive",
        refresh_token: refresh_token,
      });

      this.progress_circular = true;

      let header = {
        Authorization: "Bearer " + result_t.data.access_token,
        "Content-Type": "application/json",
      };
      let configuracion = { headers: header };

      for (var i = 0; i < this.archivos.length; i++) {
        await axios
          .post(
            "https://graph.microsoft.com/v1.0/me/drive/root:/INTRANET/COMPARTIDO/" +
              this.nombre_carpeta +
              "/" +
              this.nombre_tipo_carpeta +
              "/" +
              this.archivos[i].name +
              ":/createUploadSession",
            {},
            configuracion
          )
          .then((response) => {
            this.crearArchivo(response.data.uploadUrl, this.archivos[i]);
          });
      }
    },
    crearArchivo(uploadUrl, archivo) {
      let me = this;
      const async = require("async");

      async.eachSeries(this.getSizes(archivo), function (st, callback) {
        setTimeout(async function () {
          let header = {
            "Content-Length": st.clen,
            "Content-Range": st.cr,
          };
          let configuracion = { headers: header };
          let response = await axios.put(uploadUrl, archivo, configuracion);
          me.contador++;

          me.dialog_nuevo = false;
          me.dialog_estatus_archivos = true;
          me.progress_circular = false;
          //console.log(response.data);

          if (me.contador == me.archivos.length) {
            me.contador = 0;
            me.listarArchivos();
          }

          if (response.status == 201) {
            me.archivos_creados.push({
              estatus: "Archivo creado",
              nombre: response.data.name,
            });
          } else {
            me.archivos_creados.push({
              estatus: "Archivo no se pudo crer",
              nombre: response.data.name,
            });
          }
          callback();
        }, st.stime);
      });
    },
    getSizes(file) {
      var allsize = file.size;
      var sep = allsize < 60 * 1024 * 1024 ? allsize : 60 * 1024 * 1024 - 1;
      var ar = [];
      for (var i = 0; i < allsize; i += sep) {
        var bstart = i;
        var bend = i + sep - 1 < allsize ? i + sep - 1 : allsize - 1;
        var cr = "bytes " + bstart + "-" + bend + "/" + allsize;
        var clen = bend != allsize - 1 ? sep : allsize - i;
        var stime = allsize < 60 * 1024 * 1024 ? 5000 : 10000;
        ar.push({
          bstart: bstart,
          bend: bend,
          cr: cr,
          clen: clen,
          stime: stime,
        });
      }
      return ar;
    },
    async descargar() {
      var credenciales_drive = await one_drive_api.listarCredencialesOneDrive(
        this.$store.state.usuario.idUsuario
      );
      var refresh_token = this.desencriptarDato(
        this.getLlave("refresh_token", credenciales_drive).valor
      );
      var result_t = await axios.post("api/Usuarios/ObtenerNuevoToken", {
        redirect_uri: "http://localhost:8080/authGoogleDrive",
        refresh_token: refresh_token,
      });

      let header = {
        Authorization: "Bearer " + result_t.data.access_token,
      };
      let zip = new JSZip();
      let contador = 0;

      this.items_seleccionados.forEach((element) => {
        axios({
          url:
            "https://graph.microsoft.com/v1.0/me/drive/items/" +
            element.id +
            "/content",
          responseType: "blob",
          headers: header,
        }).then((response) => {
          contador++;
          let blob = new Blob([response.data]);
          zip.file(element.name, blob);

          if (contador == this.items_seleccionados.length) {
            zip.generateAsync({ type: "blob" }).then((blob) => {
              saveAs(blob, "Archivos.zip");
            });
          }
        });
      });
    },
    cerrarDialogNuevo() {
      this.dialog_nuevo = false;
      this.dialog_estatus_archivos = false;
      this.archivos = [];
      this.archivos_creados = [];
    },
    getLlave(clave, credenciales = []) {
      for (var i = 0; i < credenciales.length; i++) {
        if (credenciales[i]["clave"] == clave) {
          return credenciales[i];
        }
      }
    },
    desencriptarDato(data) {
      var CryptoJS = require("crypto-js");
      var bytes = CryptoJS.AES.decrypt(data, "R3gi0n@l_2@22");
      return bytes.toString(CryptoJS.enc.Utf8);
    },
    async descargarArchivos() {
      //console.log(this.tree);
      let zip = new JSZip();

      var credenciales_drive = await one_drive_api.listarCredencialesOneDrive(
        this.$store.state.usuario.idUsuario
      );
      var refresh_token = this.desencriptarDato(
        this.getLlave("refresh_token", credenciales_drive).valor
      );
      var result_t = await axios.post("api/Usuarios/ObtenerNuevoToken", {
        redirect_uri: "http://localhost:8080/authGoogleDrive",
        refresh_token: refresh_token,
      });

      let header = {
        Authorization: "Bearer " + result_t.data.access_token,
        "Content-Type": "application/json",
      };

      let contador = 0;

      this.tree.forEach((element) => {
        //console.log(element);
        axios({
          url:
            "https://graph.microsoft.com/v1.0/me/drive/items/" +
            element.id +
            "/content",
          responseType: "blob",
          headers: header,
        }).then((response) => {
          //console.log(response);
          contador++;
          let blob = new Blob([response.data]);
          zip.file(element.name, blob);

          if (contador == this.tree.length) {
            zip.generateAsync({ type: "blob" }).then((blob) => {
              saveAs(blob, "Archivos.zip");
            });
          }
        });
      });
    },
  },
};
</script>
